
import {
  SUPABASE_URL,
  SUPABASE_ANON_KEY,
  IS_PREVIEW,
  APP_ENV,
} from "@/config/env";
import logger from "@/utils/logger";

// Check if we're in a production environment directly
const isProductionEnvironment = 
  process.env.NODE_ENV === 'production' ||
  (typeof window !== 'undefined' && 
   (window.location.hostname === 'mypetid.ai' || 
    window.location.hostname.includes('vercel.app')));

// Environment validation and URL determination
export const getSupabaseConfig = () => {
  // ONLY LOG CONNECTION DETAILS IN DEVELOPMENT
  if (!isProductionEnvironment) {
    logger.devOnly("========== SUPABASE CONNECTION DETAILS ==========");
    logger.devOnly("Time of execution:", new Date().toISOString());
    logger.devOnly("Original SUPABASE_URL:", SUPABASE_URL);
    logger.devOnly("Environment type:", APP_ENV, { isProductionEnvironment, IS_PREVIEW });
    logger.devOnly("================================================");
  }

  // Check if we're in a Vercel preview deployment
  const currentUrl = typeof window !== "undefined" ? window.location.href : "";
  const isVercelPreviewUrl = currentUrl.includes("vercel.app") && !currentUrl.includes("mypetid.ai");
  const isProductionDomain = currentUrl.includes("mypetid.ai");

  // Create environment-specific storage key
  const environmentKey = SUPABASE_URL.includes("yyqodsrvslheazteialw")
    ? "mypetid-auth-token-test"
    : "mypetid-auth-token-prod";

  if (!isProductionEnvironment) {
    logger.devOnly("Using storage key:", environmentKey);
  }

  return {
    url: SUPABASE_URL,
    key: SUPABASE_ANON_KEY,
    storageKey: environmentKey,
    isProductionEnvironment,
    isVercelPreviewUrl,
    isProductionDomain
  };
};

// Clean up old tokens
export const cleanupOldTokens = () => {
  if (typeof window !== "undefined" && window.localStorage) {
    try {
      const oldToken = window.localStorage.getItem("pet-care-auth-token");
      if (oldToken) {
        if (!isProductionEnvironment) {
          logger.devOnly("Found old auth token. Cleaning up...");
        }
        window.localStorage.removeItem("pet-care-auth-token");
      }
    } catch (e) {
      logger.error("Error cleaning up old tokens:", e);
    }
  }
};
